import { connect } from 'react-redux'
import Teacher from './teacher'
import {
  getTeacher,
  getSchoolTeamId,
  isSchoolAPobbleSchool
} from '../../../../../../stores/school-team/school-team.selectors'
import {
  deleteTeacher,
  demoteTeacher,
  promoteTeacher,
  resendInvitation,
  addGroupSub,
  removeGroupSub
} from '../../../../../../stores/school-team/school-team.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'
import dateFns from 'date-fns'
import { getErrorInfo } from 'pobble-components/dist/utils'

const mapStateToProps = (state, { id, me, meRequest }) => {
  const teacher = getTeacher(state, id)
  const schoolId = getSchoolTeamId(state)
  const isPobbleSchool = isSchoolAPobbleSchool(state)
  const availableGroupSubId =
    !meRequest.pending &&
    me &&
    me.account.all_my_subscriptions_group_addons &&
    me.account.all_my_subscriptions_group_addons[0] &&
    me.account.all_my_subscriptions_group_addons.filter(
      addon => !addon.assigned_to_account_id
    )[0]
  return {
    id,
    schoolId,
    userId: !meRequest.pending && me.account && me.account.id,
    name:
      (teacher.account.full_name !== ' ' && teacher.account.full_name) ||
      'Pending registration',
    avatar: teacher.account.avatar,
    email:
      teacher.account.email_identity && teacher.account.email_identity.email,
    schoolLeader: teacher.school_leader,
    lastSignIn: teacher.account.last_sign_in_at
      ? dateFns.format(teacher.account.last_sign_in_at, 'DD/MM/YYYY HH:ss')
      : '-',
    inactive: teacher.account.long_inactivity,
    isCurrentUser: id === (!meRequest.pending && me.account && me.account.id),
    confirmed:
      teacher.account.email_identity &&
      teacher.account.email_identity.confirmed,
    canGetAGroupSub:
      teacher.account.can_school_leader_assign_subscription_group_addon_to_me,
    canSeeGroupSeatsOptions:
      !meRequest.pending &&
      me &&
      me.account.policy &&
      me.account.policy.can_see_group_seats_options,
    groupSubId:
      !meRequest.pending &&
      me &&
      me.account.all_my_subscriptions_group_addons &&
      me.account.all_my_subscriptions_group_addons[0] &&
      me.account.all_my_subscriptions_group_addons[0].subscriptions_group.id,
    availableGroupSubId:
      availableGroupSubId &&
      availableGroupSubId.subscriptions_group &&
      availableGroupSubId.subscriptions_group.id,
    assignedGroupSubId:
      teacher.account.group_subscription_assignments_from_my_school &&
      teacher.account.group_subscription_assignments_from_my_school[0] &&
      teacher.account.group_subscription_assignments_from_my_school[0]
        .subscriptions_group_id,
    assignedGroupSub:
      teacher.account.group_subscription_assignments_from_my_school &&
      teacher.account.group_subscription_assignments_from_my_school[0],
    addonId:
      teacher.account.group_subscription_assignments_from_my_school &&
      teacher.account.group_subscription_assignments_from_my_school[0] &&
      teacher.account.group_subscription_assignments_from_my_school[0].addon_id,
    schoolHasSubAlready: isPobbleSchool,
    nbOfGroupSubs:
      !meRequest.pending &&
      me &&
      me.account.all_my_subscriptions_group_addons &&
      me.account.all_my_subscriptions_group_addons[0] &&
      me.account.all_my_subscriptions_group_addons.filter(
        addon => !addon.assigned_to_account_id
      ).length
  }
}

const mapDispatchToProps = dispatch => ({
  onPromote: id => dispatch(promoteTeacher(id)).catch(errorHandler),
  onDemote: id =>
    dispatch(demoteTeacher(id)).catch(e => {
      if (getErrorInfo(e).ref === 'e0000') {
        toast.warn('You need at least one admin in the school')
      } else {
        errorHandler(e)
      }
    }),
  onRemove: (schoolId, teacherId, assignedGroupSubId, addonId) => {
    assignedGroupSubId &&
      addonId &&
      dispatch(removeGroupSub(assignedGroupSubId, addonId))
    return dispatch(deleteTeacher(schoolId, teacherId))
      .then(() => assignedGroupSubId && window.location.reload())
      .catch(errorHandler)
  },
  onResendInvitation: userId =>
    dispatch(resendInvitation(userId))
      .then(() => toast.success('The invitation has now been resent.'))
      .catch(errorHandler),
  onAddGroupSub: (groupSubId, userId) =>
    dispatch(addGroupSub(groupSubId, userId))
      .then(() => window.location.reload())
      .catch(errorHandler),
  onRemoveGroupSub: (groupSubId, addonId) =>
    dispatch(removeGroupSub(groupSubId, addonId))
      .then(() => window.location.reload())
      .catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Teacher)
)
